import React, { Suspense, lazy } from "react";
import { withStyles, List, ListItem, ListItemIcon, Collapse } from "@material-ui/core";
import UserIcon from "@material-ui/icons/AccountCircle";
import { AppLoading } from "../../../loaders/loaders";
import styles from "../moduleViewstyles";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { withFeatureFlags} from "../../../userProfile/featureFlagsContext";
import { compose } from "recompose";
import { withAppConfig } from "../../../appConfigContext";
import appConstants from "../../../appConstants";
import ToolTip from "../../common/StyledToolTip";
import DropYard from "./Optimization/DropYard";

const Parameters = lazy(() => import("./Optimization/Parameters"));
const AnchorPoint = lazy(() => import("./Optimization/AnchorPoint"));
const SpeedProfiler = lazy(() => import("./Terminal/SpeedProfiler"));
const Waves = lazy(() => import("./Terminal/Waves"));
const TerminalAccess = lazy(() => import("./Terminal/TerminalAccess"));
const FeederTerminal = lazy(() => import("./Terminal/FeederTerminal"));
const DriverPreferences = lazy(() => import("./Terminal/DriverPreferences"));
const TrailerInventory = lazy(() => import("./Terminal/TrailerInventory"));
const KPIGaols = lazy(() => import("./Terminal/KPIGoals"));
const ScenarioExplorer = lazy(() => import("./Terminal/ScenarioExplorer"));
const ImportFiles = lazy(() => import("./Terminal/ImportFiles"));
const Display = lazy(() => import("./User/Display"));
const Profile = lazy(() => import("./User/Profile"));
const Notifications = lazy(() => import("./User/Notifications"));
const RouteEquipmentPreference = lazy(() =>
  import("./Terminal/RouteEquipmentPreference")
);
const RouteMappingTool = lazy(() => import("./Terminal/RouteMappingTool"));
const Placards = lazy(() => import("./Terminal/placards"));
const HolidayManagement = lazy(() => import("./HolidayManagement/index"));
const TerminalOnboarding = lazy(() => import("./Terminal/TerminalOnboarding"));

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showImportFiles: this.showImportFiles(),
      activeModule:
        sessionStorage.getItem("activeSettingsModule") || "parameters",
    };
    this.showSpeedProfiler = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableSpeedProfiler
    );
    this.showRouteEquipmentPreference =
      this.props.featureFlags.isFeatureEnabled(
        appConstants.features.EnableRouteEquipmentPreference
      );
    this.enableTerminalOnboarding =
      this.props.configJSON.terminalOnboarding?.enableTerminalOnboarding || false;
  }

  showImportFiles = () => {
    return Boolean(this.props.featureFlags.featureFlags.find(
      (ele) => ele.id == "ShowFileUploadPage"
    )?.value)
  }
 
  componentDidUpdate(){
     const showImportFiles = this.showImportFiles();
    if(this.state.showImportFiles !== showImportFiles){
      this.setState({
        showImportFiles
      })
    }
  }

  onModuleChange = (event) => {
    const activeModule = event.target.getAttribute("data-value");
    if (activeModule) {
      this.setState({
        activeModule,
      });
      sessionStorage.setItem("activeSettingsModule", activeModule);
    }
  };

  getSubComponentModule = (activeModule) => {
    switch (activeModule) {
      case "profile":
        return <Profile />;
      case "display":
        return <Display />;
      case "waves":
        return <Waves />;
      case "terminalAccess":
        return <TerminalAccess terminalAccessLabel={this.props.configJSON.terminalAccessLabel } />;
      case "feederTerminal":
        return <FeederTerminal shouldReturnNonTerminalLocation/>;
      case "speedProfiler":
        return <SpeedProfiler />;
      case "trailerInventory":
        return <TrailerInventory />;
      case "parameters":
        return <Parameters />;
      case "scenarioExplorer":
        return <ScenarioExplorer />;
      case "importFiles":
        return <ImportFiles />;
      case "anchorPoint":
        return <AnchorPoint />;
      case "kpiGoals":
        return <KPIGaols />;
      case "notifications":
        return <Notifications />;
      case "driverPreferences":
        return <DriverPreferences />;
      case "routeEquipmentPreference":
        return <RouteEquipmentPreference />;
      case "routeMappingTool":
        return <RouteMappingTool glEventHub={this.props.glEventHub} />;
      case "placards":
        return <Placards />;
      case "geofencing":
        return <Geofencing />;
      case "holidayManagement":
        return <HolidayManagement />;
      case "TerminalOnboarding":
        return <TerminalOnboarding />;
      case "dropYard":
        return <DropYard glEventHub={this.props.glEventHub}/>;
      default:
        return "Submodule not found";
    }
  };

  render() {
    const { classes } = this.props;
    const { activeModule, showImportFiles } = this.state;
    const { isAdmin: isAdminUser } =
      (this.props.userData && this.props.userData.userProfile) || {};
    return (
      <div className={classes.settingsContainer}>
        <header
          className={classes.settingsModuleHeader}
          data-automationid="settings-title"
        >
          Settings
        </header>
        <div className={classes.settingsModuleContent}>
          <div className={classes.leftSection}>
            <List onClick={this.onModuleChange}>
              <ListItem
                classes={{
                  root: `${classes.listItemRoot} ${classes.listGroup}`,
                }}
              >
                <ListItemIcon classes={{ root: classes.iconRoot }}>
                  <UserIcon />
                </ListItemIcon>
                User
              </ListItem>
              <Collapse
                in={true}
                classes={{ container: classes.collapseContainer }}
              >
                <List classes={{ root: classes.innerListRoot }} component="nav">
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="profile"
                    selected={activeModule === "profile"}
                  >
                    Profile
                  </ListItem>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="display"
                    selected={activeModule === "display"}
                  >
                    Display
                  </ListItem>
                  {isAdminUser && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="notifications"
                      selected={activeModule === "notifications"}
                    >
                      Notifications
                    </ListItem>
                  )}
                </List>
              </Collapse>
              <ListItem
                classes={{
                  root: `${classes.listItemRoot} ${classes.listGroup}`,
                }}
              >
                <ListItemIcon classes={{ root: classes.iconRoot }}>
                  <i className="icon-terminal-2"></i>
                </ListItemIcon>
                {this.props.configJSON.terminalAccessLabel.fullName}
              </ListItem>
              <Collapse
                in={true}
                classes={{ container: classes.collapseContainer }}
              >
                <List classes={{ root: classes.innerListRoot }} component="nav">
                  {this.props.configJSON.showRouteMapping ? (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="routeMappingTool"
                      selected={activeModule === "routeMappingTool"}
                    >
                      Route Mapping Tool
                    </ListItem>
                  ) : null}

                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="waves"
                    selected={activeModule === "waves"}
                  >
                    Waves
                  </ListItem>
                  {isAdminUser && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="terminalAccess"
                      selected={activeModule === "terminalAccess"}
                    >
                      {this.props.configJSON.terminalAccessLabel.menuLabel}
                    </ListItem>
                  )}
                  <ToolTip
                    title={
                      this.props.configJSON.enableFeederTerminal
                        ? "Feeder Terminals"
                        : "Feeder Terminals (Disabled)"
                    }
                  >
                    <div>
                      <ListItem
                        button
                        classes={{
                          root: classes.listItemRoot,
                          selected: classes.listItemSelected,
                        }}
                        data-value="feederTerminal"
                        selected={activeModule === "feederTerminal"}
                        disabled={!this.props.configJSON.enableFeederTerminal}
                      >
                        Feeder Terminals
                      </ListItem>
                    </div>
                  </ToolTip>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="driverPreferences"
                    selected={activeModule === "driverPreferences"}
                  >
                    Driver Preferences
                  </ListItem>
                  {this.showSpeedProfiler && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="speedProfiler"
                      selected={activeModule === "speedProfiler"}
                    >
                      Speed Profiler
                    </ListItem>
                  )}
                  {this.showRouteEquipmentPreference && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="routeEquipmentPreference"
                      selected={activeModule === "routeEquipmentPreference"}
                    >
                      Route-Equipment Mapping
                    </ListItem>
                  )}
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="trailerInventory"
                    selected={activeModule === "trailerInventory"}
                  >
                    Trailer Inventory
                  </ListItem>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="kpiGoals"
                    selected={activeModule === "kpiGoals"}
                  >
                    KPI Goals
                  </ListItem>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="scenarioExplorer"
                    selected={activeModule === "scenarioExplorer"}
                  >
                    Scenario Explorer
                  </ListItem>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="placards"
                    selected={activeModule === "placards"}
                  >
                    Placards
                  </ListItem>
                  {isAdminUser && this.enableTerminalOnboarding && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="TerminalOnboarding"
                      selected={activeModule === "TerminalOnboarding"}
                    >
                      Terminal Onboarding
                    </ListItem>
                  )}
                  {showImportFiles && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="importFiles"
                      selected={activeModule === "importFiles"}
                    >
                      Import Files
                    </ListItem>
                  )}
                  <ToolTip
                    title={
                      this.props.configJSON.enableHolidayManagement
                        ? "Holiday Management"
                        : "Holiday Management (Disabled)"
                    }
                  >
                    <div>
                      <ListItem
                        button
                        classes={{
                          root: classes.listItemRoot,
                          selected: classes.listItemSelected,
                        }}
                        data-value="holidayManagement"
                        selected={activeModule === "holidayManagement"}
                        disabled={!this.props.configJSON.enableHolidayManagement}
                      >
                        Holiday Management
                      </ListItem>
                    </div>
                  </ToolTip>
                </List>
              </Collapse>
              <ListItem
                classes={{
                  root: `${classes.listItemRoot} ${classes.listGroup}`,
                }}
              >
                <ListItemIcon classes={{ root: classes.iconRoot }}>
                  <i className="icon-icon_opportunity"></i>
                </ListItemIcon>
                Optimization
              </ListItem>
              <Collapse
                in={true}
                classes={{ container: classes.collapseContainer }}
              >
                <List classes={{ root: classes.innerListRoot }} component="nav">
                {isAdminUser && (
                    <ListItem
                      button
                      classes={{
                        root: classes.listItemRoot,
                        selected: classes.listItemSelected,
                      }}
                      data-value="dropYard"
                      selected={activeModule === "dropYard"}
                    >
                      Drop Yards
                    </ListItem>
                  )}
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="parameters"
                    selected={activeModule === "parameters"}
                  >
                    Parameters
                  </ListItem>
                  <ListItem
                    button
                    classes={{
                      root: classes.listItemRoot,
                      selected: classes.listItemSelected,
                    }}
                    data-value="anchorPoint"
                    selected={activeModule === "anchorPoint"}
                  >
                    Anchor Points
                  </ListItem>                  
                </List>
              </Collapse>
            </List>
          </div>
          <div className={classes.rightSection}>
            <Suspense fallback={<AppLoading />}>
              {this.getSubComponentModule(activeModule)}
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withFeatureFlags,
  withUserProfile,
  withAppConfig
)(Settings);
